import { ApolloClient, ApolloLink, HttpLink } from "@apollo/client/core";
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { InMemoryCache } from '@apollo/client/cache';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { authLink } from "./authLinkF.js";
import { apiGqlPath } from "../../sharedF/apiPathsF.mts";
import { sha256Browser } from "../../sharedF/hashF/sha256BrowserAI.mts";
export const apolloLinkH = {
    credentials: 'include',
    uri: apiGqlPath,
};
const httpLink = new HttpLink(apolloLinkH);
const apolloCache = new InMemoryCache();
const mkApqLink = () => {
    if (typeof window === 'undefined')
        return null;
    const cfProxied = process.env.NEXT_PUBLIC_CF_PROXIED;
    if (!cfProxied)
        return null;
    return createPersistedQueryLink({ sha256: sha256Browser, useGETForHashedQueries: true });
};
const apqLink = mkApqLink();
export const apollo1Client = new ApolloClient({
    link: ApolloLink.from([
        authLink,
        ...(apqLink ? [apqLink] : []),
        httpLink,
    ]),
    cache: apolloCache
});
const batchHttpLink = new BatchHttpLink({ ...apolloLinkH, batchMax: 50, batchInterval: 20 }); // bump1
export const apollo1ClientBatched = new ApolloClient({
    link: ApolloLink.from([
        authLink,
        ...(apqLink ? [apqLink] : []),
        batchHttpLink,
    ]),
    cache: apolloCache
});
